<template>

  <div class='Box'>
    <el-card class="box-card">

      <!-- 查询条件 -->
      <el-form :model="queryParams" size="medium" label-width="120px">
        <el-row :gutter="35">
          <el-col :xs="24" :sm="12" :md="12" :lg="7" :xl="6" class="mb20">
            <el-form-item label="协议名称">
              <el-input v-model="queryParams.name" @change="search" @clear="search" placeholder="请输入协议名称" clearable></el-input>
            </el-form-item>
          </el-col>

          <el-col :xs="24" :sm="12" :md="12" :lg="7" :xl="6" class="mb20">
            <div class="btn_left">
              <el-button size="medium" type="primary" @click="search">查询</el-button>
              <el-button size="medium" @click="reset">重置</el-button>
            </div>
          </el-col>
        </el-row>


      </el-form>
      <!--工具栏 -->
      <div class="div_buttom">
        <el-button size="medium" @click="getList">刷新列表</el-button>
        <el-button size="medium" type="primary" icon="el-icon-plus" @click="addList">添加</el-button>
<!--        <el-button size="medium" type="primary" icon="el-icon-search" @click="addSearch">打开搜索</el-button>-->
      </div>
      <!-- 列表 -->
      <el-table ref="multipleTable" :data="tableData" tooltip-effect="dark" style="width: 100%"
                size="medium"
                :header-cell-style="{textAlign:'center',background:'#f5f7fa'}" :cell-style="{textAlign:'center'}"
                @selection-change="handleSelectionChange" border v-loading="loading">
        <el-table-column label="协议ID" width="80">
          <template slot-scope="scope">{{ scope.row.id }}</template>
        </el-table-column>

        <el-table-column prop="name" label="协议名称" min-width="160">
          <template slot-scope="scope">{{ scope.row.name }}</template>
        </el-table-column>

        <el-table-column prop="name" label="创建时间" min-width="160">
          <template slot-scope="scope">{{ scope.row.created_at }}</template>
        </el-table-column>

        <el-table-column prop="name" label="状态" width="120">
          <template slot-scope="scope">
            <el-tag type="success" v-if="scope.row.status == 1">正常</el-tag>
            <el-tag type="danger" v-else>禁用</el-tag>
          </template>
        </el-table-column>

        <el-table-column  fixed="right" label="操作" width="120">
          <template slot-scope="scope">
            <el-button type="text" size="medium" @click="addEdit(scope.row)">编辑</el-button>
            <el-button type="text" style="color: red"  size="medium" @click="handleDelete(scope.row)">删除</el-button>

          </template>

        </el-table-column>

      </el-table>
      <!-- 分页组件 -->
      <pagination
          v-show="total>0"
          :total="total"
          :page.sync="queryParams.pageNo"
          :limit.sync="queryParams.pageSize"
          @pagination="getList"
      />
      <Edit v-if="editFlag" :editFlag="editFlag" @NoneeditFlag="NoneeditFlag" @Editok="Editok" :editID="editID">
      </Edit>
    </el-card>
  </div>


</template>

<script>

import {agreementsApi} from "@/api/SystemConfig/agreements";
import Edit from "./edit.vue"
import { processErrors } from "@/utils/errorHandler";

export default {
  components: {
    Edit,
  },
  data() {
    return {
      // 表单标题
      title: "",
      // 表单
      form: {},
      // 控制搜索显示
      SearchFlag: false,
      // 查询条件
      queryParams: {
        pageNo: 1,
        pageSize: 10
      },
      // 总条数
      total: 0,
      // 列表数据
      tableData: [],
      multipleSelection: [],
      editID : "",
      editFlag: false,
      loading:false,
    };
  },
  created() {
    this.getList()
  },
  methods: {
    // 获取列表
    getList() {
      this.loading = true;
      let api = agreementsApi();
      api.getAgreementList(this.queryParams).then(res => {
        this.loading = false;
        this.tableData = res.data.data
        this.total = res.data.totalCount
      })

    },
    // 点击查询
    search() {
      this.queryParams.pageNo = 1;
      this.getList();
    },

    // 重置按钮
    reset() {
      this.queryParams = {
        pageNo: 1,
        pageSize: 10
      }
      this.getList();
    },
    // 搜索开关
    addSearch() {
      this.SearchFlag = !this.SearchFlag
    },
    handleSelectionChange(val) {
      this.multipleSelection = val
    },

    addList() {
      this.editID = ""
      this.editFlag = true
    },

    addEdit(row) {
      this.editID = row.id

      this.editFlag = true
    },

    handleDelete(row){
      let api = agreementsApi();
      this.$confirm('此操作将永久删除, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        const params = {
          id: row.id
        }
        api.del(params).then(res => {
          if (res.code == 0) {
            this.$message({
              message: '删除成功',
              type: 'success'
            });
            this.getList()

          } else {
            processErrors(res);
          }
        })
      }).catch(() => {
      });
    },

    NoneeditFlag() {
      this.editFlag = false
    },
    Editok() {
      this.getList()
      this.editFlag = false
    },
  },

  mounted() {

  },
}
</script>
<style lang='scss' scoped>

.Box {
}

.el-card__body {
  padding: 0px !important;
}

.btn_left {
  margin-left: 100px;
}

.div_buttom {
  width: 100%;
  display: flex;
  margin-bottom: 20px;
}
</style>